document.addEventListener('DOMContentLoaded', ()=>{
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  
  let swiperInstance = null;
  function initOrDestroySwiper() {
    const mediaEl = document.querySelector('.media__exceution_swiper.swiper');
    if (!mediaEl) return;
    const isMobile = window.innerWidth < 750;
    if (isMobile && !swiperInstance) {
      const mediaConfig = {spaceBetween:0,slidesPerView:1.05,pagination:{el:'.swiper-pagination',type:'progressbar'} };
      swiperInstance = new Swiper(mediaEl, mediaConfig);
    }
    if (!isMobile && swiperInstance) { swiperInstance.destroy(true, true); swiperInstance = null; }
  }
  initOrDestroySwiper();
  window.addEventListener('resize', function(event) { initOrDestroySwiper() }, true);

  const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
  if (testimonialEl) {
    const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
    if (!isIOS) {
      testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
      testimonialConfig.freeMode = true;
    }
    new Swiper(testimonialEl, testimonialConfig);
  }

  const imageBriefEl = document.querySelector('.rainforest__image_briefswiper.swiper');
  if (imageBriefEl) {
    const imageBriefConfig = { spaceBetween: 18, slidesPerView: 'auto' };
    new Swiper(imageBriefEl, imageBriefConfig);
  } 

  const relatedItemsEl = document.querySelector('.related__items_swiper.swiper');
  if (relatedItemsEl) {
    const relatedItemsConfig = { spaceBetween: 18, slidesPerView: 'auto', grabCursor: true, navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev'} };
    if (!isIOS) {
      relatedItemsConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
      relatedItemsConfig.freeMode = true;
    }
    new Swiper(relatedItemsEl, relatedItemsConfig);
  }  

  const swiperElements = document.querySelectorAll('.iconText_highPricePoint_swipe.swiper');
  if (swiperElements.length > 0) {
    swiperElements.forEach((elm, index) => {
      const config = { spaceBetween: 12, slidesPerView: 'auto', allowTouchMove: true, grabCursor: true, };
      if (!isIOS) { config.mousewheel = { forceToAxis: true, thresholdDelta: 35 }; config.freeMode = true; }
      new Swiper(elm, config);
    });
  }

  class PurchaseSelection extends HTMLElement {
    constructor() {
      super();
      this.attachEvents();
    }
    attachEvents() {
      this.querySelectorAll('.Purchase_one-time_title').forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const targetWrap = e.currentTarget.closest('.Purchase__normally_wy');
          const purchaseType = targetWrap.getAttribute('purchasetypeproduct');
          this.querySelectorAll('.Purchase__normally_wy').forEach(el => el.classList.remove('active'));
          targetWrap.classList.add('active');
          purchaseType === 'one-time' ? this.syncVariantsOneTime() : ( purchaseType === 'redirection' ? this.syncNothing()  : this.syncVariantsSubscribe() );
        });
      });
  
      ['Size-onetime', 'Size-Subscribe'].forEach(name => {
        this.querySelectorAll(`input[name="${name}"]`).forEach((input, index) => {
          input.addEventListener('change', () => {
            name === 'Size-onetime' ? this.syncVariantsOneTime() : this.syncVariantsSubscribe();
            if(document.querySelectorAll('.rainforest__bundle_subtitle').length > 0){
              document.querySelectorAll('.rainforest__bundle_subtitle').forEach((st)=>{ st.classList.add('hidden') });
              document.querySelectorAll('.rainforest__bundle_content').forEach((el)=>{
                if( el.querySelector(`.rainforest__bundle_subtitle[index="${index}"]`) ){
                  el.querySelector(`.rainforest__bundle_subtitle[index="${index}"]`).classList.remove('hidden');
                }
              })
            }
          });
        });
      });
  
      const addBtn = this.querySelector('.product-form__submit[name="add"]');
      if (addBtn) {
        addBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.querySelector('.purchaseOnetime_layoutWidget').classList.contains('active')
            ? this.productAddingCartOneTime()
            : this.productAddingCartSubscribe();
        });
      }
    }
    syncNothing() {
      this.disabledButton = this.querySelector('.product-form__submit[name="add"]');
      this.disabledButton.disabled = true;
      document.querySelector('.rainforest__sticky_button_actions').querySelector('.product-form__submit[name="add"]').disabled = true;
    }
    syncVariantsOneTime() {
      this.selectedValueOnetime();
      this.selectMasterVariant(this.choosedOneTime);
      this.UpdateAppearance('onetime');
      this.stickyAddCartUpdateOneTime();
    }
    syncVariantsSubscribe() {
      this.selectedValueSubscribe();
      this.selectMasterVariant(this.choosedSubscribe);
      this.UpdateAppearance('subscribe');
      this.stickyAddCartUpdateSubscribe();
    }
    selectedValueOnetime() {
      this.choosedOneTime = [...this.querySelectorAll('input[name="Size-onetime"]:checked')].map(input => input.value);
    }
    selectedValueSubscribe() {
      this.choosedSubscribe = [...this.querySelectorAll('input[name="Size-Subscribe"]:checked')].map(input => input.value);
    }
    getVariantData() {
      return this.variantData ||= JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }
    // edited by Skio
    getProductData() {
      return this.productData ||= JSON.parse(this.querySelector('[data-product]').textContent);
    }
    selectMasterVariant(choices) {
      this.currentVariant = this.getVariantData().find(variant =>
        !variant.options.some((opt, idx) => opt !== choices[idx])
      );
    }
    UpdateAppearance(type) {
      const layoutClass = type === 'onetime' ? '.purchaseOnetime_layoutWidget' : '.purchaseSubscribe_layoutWidget';
      const pricesEl = this.querySelector(`${layoutClass} .Buy__onceprices`);
      const submitBtns = document.querySelectorAll(`.product-form__submit[type="submit"]`);
      const stickyBtns = document.querySelectorAll('.rainforest__sticky_button_actions .product-form__submit');
      const price = (value) => (value / 100).toFixed(2);
      if (typeof this.currentVariant === 'undefined') {
        this.disabledButton = this.querySelector('.product-form__submit[name="add"]');
        this.disabledButton.disabled = false;
        document.querySelector('.rainforest__sticky_button_actions').querySelector('.product-form__submit[name="add"]').disabled = false;
      }
      if (!this.currentVariant) return;
      const comparePriceRaw = type === 'subscribe' ? (this.currentVariant.compare_at_price ? this.currentVariant.compare_at_price : this.currentVariant.price ) : this.currentVariant.compare_at_price;
      const priceRaw = type === 'subscribe' && this.currentVariant.selling_plan_allocations.length
        ? this.currentVariant.selling_plan_allocations[0].price
        : this.currentVariant.price;
      const hasDiscount = comparePriceRaw && comparePriceRaw > priceRaw;
      const comparePrice = hasDiscount ? price(comparePriceRaw) : null;
      const basePrice = price(priceRaw);
      const isAvailable = this.currentVariant.available;
      const soldOut = !isAvailable;
      const priceHTML = hasDiscount
        ? `<span class="discounted_price">$${basePrice}</span>&nbsp;<span class="normal_price">$${comparePrice}</span>`
        : `<span class="exactly_price">$${basePrice}</span>`;
      const btnText = soldOut ? (hasDiscount ? `Sold Out — $${basePrice}&nbsp;<s>$${comparePrice}</s>` : `Sold Out — $${basePrice}`)  : (hasDiscount ? `Add to Cart — $${basePrice}&nbsp;<s>$${comparePrice}</s>` : `Add to Cart — $${basePrice}`);
      if (pricesEl) pricesEl.innerHTML = priceHTML;
      [...submitBtns, ...stickyBtns].forEach(btn => {
        const label = btn.querySelector('.btn_txt_wp');
        if (label) label.innerHTML = btnText;
        btn.disabled = soldOut;
      });
      this.querySelector('[name="id"]').value = this.currentVariant.id;
      if (type === 'subscribe') {
        let planInput = this.querySelector('[name="selling_plan_id"]');
        if (!planInput) {
          planInput = document.createElement('input');
          planInput.type = 'hidden';
          planInput.name = 'selling_plan_id';
          this.appendChild(planInput);
        }
        // Filter to only use selling plans from app_id 5859381
        // edited by Skio
        const productData = this.getProductData();
        const filteredSellingPlanGroups = productData.selling_plan_groups.filter(selling_plan_group => 
          selling_plan_group.app_id === 'SKIO'
        );
        
        // Get valid selling plan IDs from filtered groups
        const validPlanIds = new Set();
        filteredSellingPlanGroups.forEach(group => {
          if (group.selling_plans) {
            group.selling_plans.forEach(plan => validPlanIds.add(plan.id));
          }
        });
        
        // Find first matching allocation
        const validAllocation = this.currentVariant.selling_plan_allocations.find(allocation =>
          validPlanIds.has(allocation.selling_plan_id)
        );
        
        if (validAllocation) {
          planInput.value = validAllocation.selling_plan_id;
        } else {
          console.warn('No selling plan allocations found for app_id SKIO');
          planInput.value = this.currentVariant.selling_plan_allocations[0].selling_plan_id; // fallback
        }
        // edited by Skio
      } else {
        const planInput = this.querySelector('[name="selling_plan_id"]');
        if (planInput) planInput.remove();
      }
      const productHandle = document.querySelector('.rainforest__mainpdp_layout')?.dataset.productUrl;
      if (productHandle) {
        window.history.replaceState(null, '', `${productHandle}?variant=${this.currentVariant.id}`);
      }

    }
    stickyAddCartUpdateOneTime() {
      document.querySelector('.sticky_subscribe_message')?.classList.remove('hidden');
      document.querySelector('.sticky_shipping_message')?.classList.add('hidden');
      if (!typeof this.currentVariant === 'undefined') {
        document.querySelector('.rainforest__sticky_content_option').classList.remove('hidden');
        document.querySelector('.rainforest__sticky_content_option').innerHTML = `${this.currentVariant.title}  |  Free Shipping`;
      }else{
        document.querySelector('.rainforest__sticky_content_option').classList.add('hidden');
      }
    }
    stickyAddCartUpdateSubscribe() {
      const delivery = this.querySelector('[name="Size-Subscribe"]:checked')?.closest('.Purchase__selection_variants')?.querySelector('.DeliveryMsgBuoy st')?.innerHTML || '';
      document.querySelector('.sticky_subscribe_message')?.classList.add('hidden');
      document.querySelector('.sticky_shipping_message')?.classList.remove('hidden');
      if (!typeof this.currentVariant === 'undefined') {
        document.querySelector('.rainforest__sticky_content_option').classList.remove('hidden');
        document.querySelector('.rainforest__sticky_content_option').innerHTML = `${this.currentVariant.title}  |  ${delivery}`;
      }else{
        document.querySelector('.rainforest__sticky_content_option').classList.add('hidden');
      }
    }
    productAddingCartOneTime() {
      this.handleAddToCart({
        id: this.querySelector('[name="id"]').value,
        quantity: 1,
      });
    }
    productAddingCartSubscribe() {
      this.handleAddToCart({
        id: this.querySelector('[name="id"]').value,
        quantity: 1,
        selling_plan: this.querySelector('[name="selling_plan_id"]').value
      });
    }
    handleAddToCart(item) {
      const submitBtn = this.querySelector('.product-form__submit[name="add"]');
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.enableLoading();
      const bundleCart = {
        items: [item],
        sections: cartDrawer?.getSectionsToRender()?.map(s => s.section) || [],
        sections_url: window.location.pathname
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(bundleCart),
        credentials: 'same-origin'
      }).then(res => res.json())
        .then(data => cartDrawer?.renderContent(data.sections))
        .catch(console.error)
        .finally(() => {
          if (cartDrawer) {
            cartDrawer.disableLoading();
            cartDrawer.open();
          }
          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
        });
    }
  }
  customElements.define('cus-selection-variants', PurchaseSelection);

  if( document.querySelectorAll('.video__playIcon').length > 0 ){
    document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
      })
    });
    document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
      elm.addEventListener('click', (target)=>{
        target.preventDefault();
        target.currentTarget.classList.add('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
        target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
      })
    });  
  }

  if( document.querySelectorAll('[js-doctor-dietitian-lightbox]').length > 0 ){
    document.querySelectorAll('[js-doctor-dietitian-lightbox]').forEach((elm)=>{
      elm.addEventListener('click',(target)=>{
        target.preventDefault();
        let lighhtbox_doctor = document.querySelector('.doctor_dietitian_lightbox_html').innerHTML;
        document.querySelector('.doctor_dietitian_lightbox').innerHTML = lighhtbox_doctor;
        document.querySelector('.doctor_dietitian_lightbox').classList.add('active');
        document.querySelector('.page-overlay').classList.add('is-visible');
        document.body.classList.add('overflow-hidden');
      })
    })   
  }
  
  class doctorDietitian extends HTMLElement{
    constructor(){
      super();
      this.querySelectorAll('[js-doctor-dietitian-lightbox-close]').forEach((elm)=>{
        elm.addEventListener('click',(target)=>{
          target.preventDefault();
          document.querySelector('.doctor_dietitian_lightbox').innerHTML = ``;
          document.querySelector('.doctor_dietitian_lightbox').classList.remove('active');
          document.querySelector('.page-overlay').classList.remove('is-visible');
          document.body.classList.remove('overflow-hidden');
        })
      })       
    }
  }
  window.customElements.define('cus-dietitian-widget',doctorDietitian);

  function isInViewport(elem) {
    const rect = elem.getBoundingClientRect();
    return (
      rect.bottom >= 0 &&
      rect.right >= 0 &&
      rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }
  
  const stickyBar = document.querySelector('.rainforest__sticky_button_actions');
  const header = document.querySelector('.section-header');
  const headerHeight = header ? header.clientHeight : 0;
  const addToCartElements = document.querySelectorAll('[js-scroll-identity]');
  const footerSections = document.querySelectorAll('.footer__main_wrapper');
  const recentlyViewedSections = document.querySelectorAll('[section="product-recently-viewed"]');
  
  function shouldHideSticky() {
    for (const el of [...addToCartElements, ...footerSections, ...recentlyViewedSections]) {
      if (el && isInViewport(el)) return true;
    }
    return false;
  }
  
  function handleStickyScroll() {
    const scrollY = window.scrollY;
    const triggerElement = document.querySelector('[js-scroll-identity]');
    if (!triggerElement || !stickyBar) return;
    const triggerOffset = triggerElement.offsetTop;
    if (scrollY > triggerOffset) {
      if (shouldHideSticky()) {
        stickyBar.classList.remove('stickyAddToCart');
        stickyBar.style.top = `-100%`;
      } else {
        stickyBar.classList.add('stickyAddToCart');
        stickyBar.style.top = `${headerHeight}px`;
      }
    } else {
      stickyBar.classList.remove('stickyAddToCart');
      stickyBar.style.top = `-100%`;
    }
  }
  window.addEventListener('scroll', handleStickyScroll, { passive: true });

  const stickyButton = document.querySelector('.rainforest__sticky_button_actions .rainforest__buttonScroll');
  const scrollTarget = document.querySelector('.custom-product-form-xt');
  if (stickyButton && header && scrollTarget) {
    stickyButton.addEventListener('click', (e) => {
      e.preventDefault();
      const offset = scrollTarget.offsetTop - header.clientHeight;
      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    });
  }
    
  const stickyFormContainer = document?.querySelector('.rainforest__sticky_button_actions');
  const productForm = document?.querySelector('.custom-product-form-xt');
  const cartDrawerSticky = document?.querySelector('cart-drawer');
  if (stickyFormContainer && productForm) {
    const submitBtn = stickyFormContainer.querySelector('.product-form__submit');
    submitBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      const isOneTime = document.querySelector('.purchaseOnetime_layoutWidget')?.classList.contains('active');
      const variantId = productForm.querySelector('[name="id"]')?.value;
      const sellingPlanId = productForm.querySelector('[name="selling_plan_id"]')?.value;
      if (!variantId) return;
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;
      const item = { id: variantId, quantity: 1 };
      if (!isOneTime && sellingPlanId) item.selling_plan = sellingPlanId;
      const bundleCart = {
        items: [item],
        sections: cartDrawerSticky?.getSectionsToRender()?.map(section => section.section) || [],
        sections_url: window.location.pathname
      };
      cartDrawerSticky?.enableLoading();
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(bundleCart),
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(parsedState => {
        cartDrawerSticky?.renderContent(parsedState.sections);
      })
      .catch(console.error)
      .finally(() => {
        cartDrawerSticky?.disableLoading();
        cartDrawerSticky?.open();
        submitBtn.classList.remove('loading');
        submitBtn.disabled = false;
      });
    });
  }

  if( document?.querySelectorAll('[js-widget-overview]').length > 0 ){
    document?.querySelectorAll('[js-widget-overview]').forEach((el)=>{
      el.addEventListener('click', (target) => {
        target.preventDefault();
        const offsetRvw = document?.querySelector('.custom__product__widget').offsetTop - header.clientHeight - stickyFormContainer.clientHeight;
        window.scrollTo({
          top: offsetRvw,
          behavior: 'smooth'
        });
      })
    })
  }  

  const timelineItems = document.querySelectorAll('.timeline-item');
  const progressDots = document.querySelectorAll('.progress-dot');
  const progressBar = document.getElementById('progressBar');
  const progressContainer = document.querySelector('.progress-container');

  if (progressContainer || progressBar || timelineItems.length != 0 || progressDots.length != 0){
    function debounce(func, wait = 100) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
    function alignDotsToItems() {
      let cumulativeHeight = 0;
      timelineItems.forEach((item, index) => {
        const itemHeight = item.offsetHeight;
        const itemStyle = window.getComputedStyle(item);
        const marginBottom = parseFloat(itemStyle.marginBottom) || 0;
        if (progressDots[index]) {
          progressDots[index].style.top = `${cumulativeHeight}px`;
        }
        cumulativeHeight += itemHeight + marginBottom;
      });
      updateProgressBarHeight();
      adjustProgressContainerHeight();
    }
  
    function updateProgressBarHeight() {
      const activeDots = Array.from(progressDots).filter(dot => dot.classList.contains('active'));
      if (activeDots.length === 0) {
        progressBar.style.height = '0px';
        return;
      }
      const firstTop = parseFloat(progressDots[0].style.top) || 0;
      const lastActiveDot = activeDots[activeDots.length - 1];
      const lastTop = parseFloat(lastActiveDot.style.top) || 0;
      progressBar.style.top = `${firstTop}px`;
      progressBar.style.height = `${lastTop - firstTop}px`;
    }
  
    function setActiveDotByScroll() {
      const viewportCenter = window.innerHeight / 2;
      let activeIndex = 0;
      let minDistance = Infinity;
      timelineItems.forEach((item, index) => {
        const rect = item.getBoundingClientRect();
        const itemMiddle = rect.top + rect.height / 2;
        const distance = Math.abs(itemMiddle - viewportCenter);
        if (distance < minDistance) {
          minDistance = distance;
          activeIndex = index;
        }
      });
      timelineItems.forEach((item, index) => {
        const isActive = index <= activeIndex;
        item.classList.toggle('center-stage', index === activeIndex);
        progressDots[index]?.classList.toggle('active', isActive);
      });
      updateProgressBarHeight();
    }
  
    function adjustProgressContainerHeight() {
      const firstDotTop = progressDots[0].offsetTop;
      const lastDot = progressDots[progressDots.length - 1];
      const lastDotTop = lastDot.offsetTop;
      const lastDotHeight = lastDot.offsetHeight;
      const lastDotStyle = window.getComputedStyle(lastDot);
      const lastDotMarginBottom = parseFloat(lastDotStyle.marginBottom) || 0;
      const height = (lastDotTop + lastDotHeight + lastDotMarginBottom) - firstDotTop;
      progressContainer.style.height = `${height}px`;
    }
    const updateLayout = () => {
      alignDotsToItems();
      setActiveDotByScroll();
    };
    const debouncedUpdate = debounce(updateLayout, 100);
    window.addEventListener('scroll', debounce(setActiveDotByScroll, 50));
    window.addEventListener('resize', debouncedUpdate);
    requestAnimationFrame(() => {
      debouncedUpdate();
      setTimeout(debouncedUpdate, 150);
    });
    const observer = new ResizeObserver(debouncedUpdate);
    timelineItems.forEach(item => observer.observe(item));
    let tries = 0;
    const maxTries = 10;
    const retryLoop = () => {
      debouncedUpdate();
      if (++tries < maxTries) {
        setTimeout(retryLoop, 300);
      }
    };
    retryLoop();
  }
  
  function setupMarquee({ contentId, containerSelector, speed = 0.5 }) {
    const scrollingContent = document.getElementById(contentId);
    if (!scrollingContent) {
      console.warn(`Marquee setup failed: Element with ID "${contentId}" not found.`);
      return;
    }
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Marquee setup failed: Container with selector "${containerSelector}" not found.`);
      return;
    }
    scrollingContent.innerHTML += scrollingContent.innerHTML;
    let x = 0;
    let isPaused = false;
    function animate() {
      if (!isPaused) {
        x -= speed;
        if (Math.abs(x) >= scrollingContent.scrollWidth / 2) {
          x = 0;
        }
        scrollingContent.style.transform = `translateX(${x}px)`;
      }
      requestAnimationFrame(animate);
    }
    container.addEventListener("mouseenter", () => { isPaused = true; });
    container.addEventListener("mouseleave", () => { isPaused = false; });
    animate();
  }
  setupMarquee({ contentId: "marqueeContent", containerSelector: ".scrolling__card_content", speed: 0.4 });
  setupMarquee({ contentId: "scrollingContent", containerSelector: ".squeeze_scroller_main", speed: 0.5 });

})